<template>
  <div class="oneonone-wrapper">
    <div class="intro">
      <div class="intro-block one">
        <h4>针对性的讲评</h4>
        <ul class="intro-content">
          <li>主带老师+邀约老师，多位讲师与学生1对1教授</li>
          <li>讲师来自海外知名院校、世界知名事务所</li>
          <li>个性化学习规划与辅导，有条不紊的做好作品集</li>
          <li>申请、求职、面试辅导，针对性指导</li>
        </ul>
      </div>
      <div class="intro-block two">
        <h4>更负责的跟进监督体制</h4>
        <ul class="intro-content">
          <li>期中、期末评图，把控教学进度</li>
          <li>专业教务老师帮助选择讲师</li>
          <li>全程监督跟进教学过程，问题及时反馈解决</li>
          <li>基于数据的教务系统，每个学生都有足够的关注</li>
        </ul>
      </div>
    </div>
    <div class="teachers">
      <div class="oneonone-title">
        <h2>师资信息</h2>
        <div>FACULTY</div>
      </div>
      <div class="teahcers-swiper on-swipeing" id="teacherSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide teacher-card" v-for="item in teachers" @click="toTeacherDetail(item.id)">
            <div class="teacher-avatar lazy-load"><img :src="item.avatar" alt=""></div>
            <div class="teacher-info">
              <div class="name">{{item.stagename}}</div>
              <div class="tag">{{item.major_tags}}</div>
              <div class="titles">
                <span>{{item.title1}}</span>
                <span>{{item.title2}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="teahcers-pagination"></div>
      </div>
      <div class="more-teacher">
        <router-link to="/teahcer">了解更多</router-link>
      </div>
    </div>
    <div class="comments">
      <div class="oneonone-title">
        <h2>学生评价</h2>
        <div>STUDENT COMMENTS</div>
      </div>
      <div class="comments-list" :class="{'show-all': showAllComments}">
        <div class="comment-item" v-for="item in commentData">
          <div class="info">
            <div class="avatar"><img :src="item.avatar" alt=""></div>
            <div class="student">
              <div class="name">{{item.name}}</div>
              <div class="offer">offer：{{item.offers}}</div>
            </div>
          </div>
          <div class="comment">{{item.comment}}</div>
        </div>
      </div>
      <div class="show-all-comments" @click="showAllExp" v-show="!showAllComments">更多经验分享</div>
    </div>
    <div class="cano-intro">
      <div class="intro-text">
        <p>
          <span>凯诺设计课</span>（Canopy Institute of Design）是一所线上设计教育学院，教学实践始于2012年。凯诺的总顾问由曾任康奈尔大学建筑系主任十年之久的Jerry Wells教授担任，<strong>目前拥有毕业于哈佛、康奈尔、宾大、UCL、TUD等海外设计名校的250余人讲师团队，凯诺校友圈人数已逾1800人</strong>，遍布哈佛、康奈尔、MIT、UCL等海外名校，专业覆盖建筑、 景观、城市、室内、交互设计、服务设计、工业设计、视觉传达等设计领域。
        </p>
        <p v-show="introAllShow">
          凯诺坚持严格的讲师筛选制度，讲师来自其所在地区<strong>Top5院校，具备丰富实践经验</strong>，多位讲师获得美国注册建筑师、英国皇家注册建筑师、荷兰注册城市规划师等行业资格，职业背景覆盖SOM、隈研吾、福斯特、AECOM、Intel、Salesforce、阿里、Uber等各大知名设计事务所或互联网公司，讲师团也不乏在海外院校执教的老师。申请凯诺讲师需通过初筛、面试、试讲三层筛选，才获得资格成为凯诺讲师，入职后经过培训和考核才能开始授课，<strong>在教学过程也有资深教研组老师进行教学环节把控，并把学生的反馈及时反馈给老师。对老师和课程质量的严格追求，是凯诺的核心竞争力。</strong>
        </p>
        <div class="show-all-intro" @click="introAllShow = !introAllShow" v-show="!introAllShow">展开全文</div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  @img-path: '/Application/Home/Resource/static/images/mobile/oneonone/';
  .oneonone-wrapper{
    padding-top: .12rem;
    .oneonone-title{
      text-align: center;
      h2{
        font-size: 18px;
        line-height: 20px;
        font-weight: 600;
        color: #333;
      }
      div{
        margin-top: 8px;
        font-size: 14px;
        line-height: 14px;
        color: @cano;
      }
    }
    .intro{
      .intro-block{
        width: 100%;
        height: 1.68rem;
        padding: .2rem .2rem .24rem;
        color: #FFF;
        display: flex;
        flex-direction: column;
        &:last-child{
          margin-top: .08rem;
        }
        &.one{
          background: url('@{img-path}one-on-one-01.png') no-repeat center center;
          background-size: cover;
          align-items: flex-start;
        }
        &.two{
          background: url('@{img-path}one-on-one-02.png') no-repeat center center;
          background-size: cover;
          align-items: flex-end;
          .intro-content{
            text-align: right;
          }
        }
        h4{
          font-size: 16px;
          line-height: 16px;
          font-weight: bold;
        }
        .intro-content{
          margin-top: .24rem;
          font-size: 12px;
          line-height: 12px;
          li{
            margin-bottom: .12rem;
            &:last-child{
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .teachers{
      margin-top: 40px;
      .teahcers-swiper{
        position: relative;
        padding: 0 20px;
        margin-top: 16px;
        .teacher-card{
          width: 1.66rem;
          height: 2.68rem;
          background: #FFF;
          box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
          border-radius: 8px;
          overflow: hidden;
          .teacher-avatar{
            width: 100%;
            height: 1.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            img{
              width: 100%;
            }
          }
          .teacher-info{
            padding: 10px 12px;
            .name{
              font-size: 16px;
              line-height: 22px;
              color: #333;
              font-weight: 600;
            }
            .tag{
              margin-top: 4px;
              padding: 0 4px;
              height: 18px;
              line-height: 18px;
              font-size: 12px;
              color: @cano;
              background: rgba(77, 162, 199, 0.2);
              display: inline-flex;
              justify-content: center;
              align-items: center;
              border-radius: 18px;
              white-space: nowrap;
            }
            .titles{
              display: flex;
              flex-direction: column;
              font-size: 12px;
              line-height: 18px;
              color: #666;
              margin-top: 8px;
              span{
                margin-bottom: 4px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                &:last-child{
                  margin-bottom: 0;
                }
              }
            }
          }
        }
        .teahcers-pagination{
          position: absolute;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          bottom: -26px;
        }
      }
      .more-teacher{
        margin-top: .4rem;
        display: flex;
        justify-content: center;
        a{
          display: inline-flex;
          width: 1.95rem;
          height: .42rem;
          background: linear-gradient(270deg, #2B7CEB 0%, #58BAEA 100%);
          border-radius: 42rem;
          color: #FFF;
          font-size: 14px;
          font-weight: 600;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all .2s;
          &:active{
            opacity: .8;
          }
        }
      }
    }
    .comments{
      margin-top: .4rem;
      .comments-list{
        position: relative;
        margin-top: 16px;
        padding: 0 20px;
        height: 528px;
        overflow: hidden;
        &.show-all{
          height: auto;
          &::after{
            width: 0;
            height: 0;
          }
        }
        &::after{
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: .93rem;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
        }
        .comment-item{
          height: 1.6rem;
          overflow: hidden;
          margin-bottom: 12px;
          background: #FFF;
          border-radius: 3px;
          box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
          padding: .2rem .14rem .19rem;
          .info{
            display: flex;
            align-items: center;
            padding-bottom: 12px;
            border-bottom: 1px solid #EEE;
            .avatar{
              width: .7rem;
              height: .4rem;
              flex-shrink: 0;
              img{
                width: 100%;
              }
            }
            .student{
              padding-left: 9px;
              min-width: 0;
              .name{
                font-size: 14px;
                line-height: 14px;
                color: #333;
                font-weight: bold;
              }
              .offer{
                color: @cano;
                font-size: 14px;
                line-height: 14px;
                margin-top: 10px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
          .comment{
            padding-top: 8px;
            font-size: 13px;
            line-height: 20px;
            color: #666;
          }
        }
      }
      .show-all-comments{
        width: 1.95rem;
        height: .42rem;
        margin: 0 auto;
        background: linear-gradient(270deg, #2B7CEB 0%, #58BAEA 100%);
        border-radius: 42rem;
        color: #FFF;
        font-size: 14px;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all .2s;
        &:active{
          opacity: .8;
        }
      }
    }
    .cano-intro{
      position: relative;
      margin-top: 40px;
      width: 100%;
      padding: .32rem .54rem .44rem;
      background: linear-gradient(180deg, #E6EFF5 0%, #F5F9FA 100%);
      &::after{
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        width: 1.5rem;
        height: 2.96rem;
        background: url('@{img-path}introduce-building-bg.png') no-repeat center center;
        background-size: cover;
      }
      .intro-text{
        position: relative;
        z-index: 10;
        p{
          font-size: 14px;
          line-height: 26px;
          color: #333;
          &:not(:first-child) {
            margin-top: 30px;
          }
          span{
            font-weight: bold;
            color: @cano;
          }
        }
        .show-all-intro{
          margin-top: 16px;
          display: inline-flex;
          position: relative;
          font-size: 13px;
          line-height: 13px;
          color: @cano;
          &::after{
            content: '';
            position: absolute;
            right: -12px;
            top: 50%;
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border-width: 4px;
            border-color: @cano transparent transparent transparent;
            border-style: solid dashed dashed dashed;
          }
        }
        &::before,
        &::after{
          content: '';
          position: absolute;
          width: 24px;
          height: 24px;
          background: url('@{img-path}quot.png') no-repeat center center;
          background-size: cover;
        }
        &::before{
          left: -.36rem;
          top: 0;
        }
        &::after{
          right: -.36rem;
          bottom: -.24rem;
          transform: rotate(180deg);
        }
      }
    }
  }
</style>

<style lang="less">
  .teahcers-pagination{
    .swiper-pagination-bullet{
      width: 4px;
      height: 4px;
      &.swiper-pagination-bullet-active{
        background: @cano;
      }
    }
  }
</style>

<script>
  import Swiper, { Navigation, Pagination } from 'swiper'
  import Header from '@/components/Common/header.vue'
  export default {
    data() {
      return {
        teachers: [],
        teacherSwiper: null,
        commentData: [
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-01.png',
            name: '彭元麓',
            background: '天津大学',
            major: '设计研究',
            offers: '哈佛大学，伦敦大学学院',
            comment: '“莫老师在方案的深化阶段和图面上都给予了我许多建议；王老师的灵魂诘问是我受益终生的药方。班培颖老师让我体会到了一个设计从无到有的过程。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-02.png',
            name: '解丹',
            background: '华南理工大学',
            major: '建筑',
            offers: '代尔夫特理工大学，埃因霍芬理工大学，米兰理工大学',
            comment: '“感谢王雨田老师，给我非常多精准的建议；感谢莫万莉老师，让我对纯粹的概念设计有了更深入的实践；还要感谢张世杰老师和蔡澄老师的耐心指导。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-03.png',
            name: '秦诗雨',
            background: '北京林业大学',
            major: '城市设计',
            offers: '伦敦大学学院，谢菲尔德大学，卡迪夫大学，瑞典皇家理工学院，曼彻斯特城市大学，威斯敏斯特大学，新加坡国立大学',
            comment: '“感谢不断帮我理清思路的王一楠老师帮我看图，指出问题和修改方法，大到整体的排版，小到字体字号。 感谢鼓励我勇敢尝试的Wendy老师。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-04.png',
            name: '庄琪',
            background: '东南大学',
            major: '城市设计',
            offers: '新加坡国立大学，香港大学，谢菲尔德大学',
            comment: '“原本以为报机构做作品集会是一个很功利主义的学习过程，但实际上这几个月的学习强度超出了我的想象，非常感谢凯诺这个学习平台。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-05.png',
            name: '吴芃延',
            background: '加州大学洛杉矶分校',
            major: '建筑',
            offers: '哈佛大学设计学院，哥伦比亚大学',
            comment: '“感谢孟澍老师和Fengqi Li老师帮我梳理作品集和文书并且给予针对性的意见。我这次本来是抱着试试的态度，但没有想到竟然得到了自己满意的offer。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-06.png',
            name: '唐天阳',
            background: '青岛理工大学',
            major: '建筑',
            offers: '德国达姆施塔特工业大学，德国卡尔斯鲁厄理工学院，德国布伦瑞克工业大学',
            comment: '“感谢沈嘉明老师教了我很多构造方面的知识，并且教我绘制节点大样图，细心批改我的每一份作业。感谢甘煜群和戴安琪老师，带我用不同的角度做设计。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-07.png',
            name: '施笑晨',
            background: '同济大学',
            major: '交互/服务',
            offers: '密歇根大学，马里兰大学，印第安纳大学伯明顿分校',
            comment: '“很喜欢雪诗老师高效的上课和交流方式，也谢谢老师按住我时不时泛起来的焦虑情绪。感谢studio带过我的各位老师，感谢帮我修改、转发推荐信的老师。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-08.png',
            name: '韩奇',
            background: '华中科技大学',
            major: '交互/服务',
            offers: '米兰理工大学，拉夫堡大学，格拉斯哥艺术学院，伦敦艺术大学，爱丁堡大学',
            comment: '“感谢帮我整理选校的Michelle Zhou老师，沟通了方向之后，我对项目方向有了初步了解；感谢在博物馆设计项目中给我很多灵感和启发的Eva Chen老师。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-09.png',
            name: '葛嘉铭',
            background: '北方工业大学',
            major: '景观',
            offers: '爱丁堡大学，都柏林大学，悉尼大学，昆士兰大学，西澳大学，新南威尔士大学，阿德莱德大学，纽卡斯尔大学',
            comment: '“感谢凯诺让我在设计、专业知识方面更上一层楼，感谢我的主带王潇阳老师，细心解答我的每一个问题。感谢黄东柠老师，每一次图纸批改都非常详细透彻。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-10.png',
            name: '唐中慧',
            background: '北京林业大学',
            major: '景观',
            offers: '宾夕法尼亚大学，康奈尔大学，加州大学伯克利分校，华盛顿大学，弗吉尼亚大学，伊利诺伊理工大学',
            comment: '“感谢我的主带蔡伊凡老师。李其轩老师，帮我逐字逐句地斟酌文书内容。王雪诗老师，一直给我鼓励和陪伴。胡月辰老师，帮我梳理方案的思路。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-11.png',
            name: '夏荣',
            background: '南京林业大学',
            major: '建筑',
            offers: '德国慕尼黑工业大学，德国汉诺威大学，德国卡塞尔大学',
            comment: '“作品集制作的过程中，刘书菡老师将宾大的设计体系悉心讲解，使我对于设计过程中的细节把控、思考逻辑都有了巨大的提升。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-12.png',
            name: '王悦',
            background: '山西农业大学',
            major: '景观',
            offers: '多伦多大学,英属哥伦比亚大学',
            comment: '“感谢张曈曈老师的引导和建议。感谢Yuechen Hu老师让我在申请过程中体验到最开心，成长最大的一段设计过程。 也感谢凯诺让我见到了更大的世界。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-14.png',
            name: '涂凯茜',
            background: '西交利物浦大学',
            major: '建筑',
            offers: '哥伦比亚大学 加州大学洛杉矶分校 密歇根大学 圣路易斯华盛顿大学 加州大学伯克利分校 南加州大学 宾夕法尼亚大学',
            comment: '“感谢莫万莉老师帮我重新整理思路。吴莲洁老师的小组课和一对一都非常有逻辑。强烈推荐Layla Tan老师的文书修改！改得非常仔细，语法上有了质的提升。”'
          },
          {
            avatar: '/Application/Home/Resource/static/images/mobile/oneonone/student-13.png',
            name: '颜晓航',
            background: '高中',
            major: '建筑',
            offers: '康奈尔大学 Early Decision',
            comment: '“申请本科建筑或者做作品集不是一朝一夕就可以完成的工作，需要不断地积累。非常感谢大旻不辞辛苦，在作品集和申请上帮助我这么多。”'
          },
        ],
        showAllComments: false,
        introAllShow: false,
      }
    },
    components: {
      Header
    },
    created() {
      this.$root.post('/Lecturer/get_featured_teacher').then(data => {
        this.teachers = data || [];
        this.$nextTick(() => {
          this.$emit('update');
          this.teacherSwiper = new Swiper('#teacherSwiper', {
            slidesPerView: 'auto',
            freeMode: true,
            pagination: {
              el: '.teahcers-pagination',
              clickable: true,
            },
          });
        })
      })
    },
    methods: {
      toTeacherDetail(id) {
        this.$router.push({name: 'LecturerDetail', params: {id: id}});
      },
      showAllExp() {
        this.showAllComments = true;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Course/oneonone.vue